import { render, staticRenderFns } from "./RestricoesVendaAba.vue?vue&type=template&id=5f88dd8d&scoped=true&"
import script from "./RestricoesVendaAba.vue?vue&type=script&lang=js&"
export * from "./RestricoesVendaAba.vue?vue&type=script&lang=js&"
import style0 from "./RestricoesVendaAba.vue?vue&type=style&index=0&id=5f88dd8d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88dd8d",
  null
  
)

export default component.exports